import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

type SaveLegacyConfirmationModalProps = {
	readonly onClose: () => void;
	readonly onConfirm: () => void;
	readonly companyName: string;
};

export function SaveLegacyConfirmationModal({
	onClose,
	onConfirm,
	companyName,
}: SaveLegacyConfirmationModalProps) {
	return (
		<TraxModal
			confirmText={"Save"}
			onCancel={onClose}
			onClose={onClose}
			onConfirm={onConfirm}
			title={"Saving Address to New TRAX"}
			type={"confirmation"}
			width={"25%"}
		>
			<p>
				You are about to save <strong>{companyName}</strong> to the New TRAX
				Address Book. Once you click save, the Legacy icon will be removed from
				view, and the Address will be saved in the New TRAX Address Book.
			</p>
		</TraxModal>
	);
}
